import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import '../styles/css/QuizTable.css';
import { connect } from 'react-redux';
import Spinner from '../components/Spinner';
import { pageView, trackEvent } from '../util/tracking';
import {
  AssignmentDetails,
  AssignmentTitle
} from '../components/AssignmentDetails';
import { getAssignments } from '../actions/DashboardAction';

// const dayIndexArray = { day1: 0, day2: 1, day3: 2, quiz: 3 };

//<DayInfoTable dailyData={this.props.dailyData} title={title}
//  week={week} day={day} />
class AssignmentContainer extends React.Component {
  // state = {
  //   tmp: true,
  //   dailyData: null
  // };
  componentDidMount() {
    const { category, memberChapterId } = this.props.match.params;
    this.props.getAssignments(memberChapterId, category);
  }
  // componentDidMount() {
  //   const { day, week } = this.props.match.params;
  //   let weekId = this.props.chapters[week - 1].id;

  //   if (
  //     weekId !== this.props.dailyData.weekId ||
  //     day !== this.props.dailyData.day
  //   ) {
  //     this.setState({ dailyData: null, day: day });
  //     this.props.getDay(weekId, day);
  //   } else if (
  //     weekId === this.props.dailyData.weekId &&
  //     day === this.props.dailyData.day
  //   ) {
  //     this.setState({ dailyData: this.props.dailyData });
  //   }
  //   pageView();
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.dailyData !== nextProps.dailyData) {
  //     this.setState({
  //       dailyData: nextProps.dailyData
  //     });

  //     if (nextProps.dailyData.day === 'quiz') {
  //       let sound_array = this.createSoundState(nextProps.dailyData.data[0]);
  //       this.setState({
  //         sound: sound_array,
  //         default_sound: sound_array
  //       });
  //     }
  //   }
  // }

  // onPatternClick(evt) {
  //   let dailyData = { ...this.state.dailyData };
  //   let patternSet = dailyData.data.filter(val => val.type === 'pattern');
  //   patternSet[0].sets[0].set = patternSet[0].sets[0].examples[evt];
  //   patternSet[0].sets[0].exp = patternSet[0].sets[0].patterns[evt];
  //   patternSet[0].sets[0].selected = `Pattern ${evt + 1}`;

  //   this.setState({ dailyData: dailyData });
  //   trackEvent('DASHBOARD', 'Click Pattern Pracite', 'Pattern' + (evt + 1));
  // }

  // createSoundState(data) {
  //   let quiz_length = data.sets.length;
  //   let sound_array = [];

  //   for (let i = 0; i < quiz_length; i++) {
  //     let jsonObj = {
  //       material: 'STOPPED',
  //       question: 'STOPPED',
  //       choices: Array(data.sets[i].body.length).fill('STOPPED')
  //     };
  //     sound_array.push(jsonObj);
  //   }

  //   return sound_array;
  // }

  // onAudioPlay(i, j, evt) {
  //   // can change the icon here (probably just display)
  //   let tmpSound = [...this.state.sound];

  //   if (evt.currentTarget.name === 'question') {
  //     tmpSound[i].question = 'PLAYING';
  //     tmpSound[i].choices = Array(tmpSound[i].choices.length).fill('STOPPED');
  //   } else if (evt.currentTarget.name === 'material') {
  //     tmpSound[i].material = 'PLAYING';
  //     tmpSound[i].choices = Array(tmpSound[i].choices.length).fill('STOPPED');
  //   } else {
  //     // one of choices audio file
  //     tmpSound[i].question = 'STOPPED';
  //     tmpSound[i].choices = Array(tmpSound[i].choices.length).fill('STOPPED');
  //     tmpSound[i].choices[j] = 'PLAYING';
  //   }

  //   this.setState({
  //     sound: tmpSound
  //   });
  // }

  // onAudioEnd(evt) {
  //   this.setState({
  //     sound: [...this.state.default_sound]
  //   });
  // }

  render() {
    const { chapterNumber, category } = this.props.match.params;
    const chapterTitle = this.props.chapters[chapterNumber - 1].name;
    let { assignments } = this.props;
    if (category === 'vocabulary') {
      assignments =  assignments['voca_list']
    } else {
      assignments =  assignments[category + '_list']
    }
    // const isCompleted = this.props.chapters[chapterNumber - 1].details[category];

    // const handlers = {
    //   // onAudioPlay: this.onAudioPlay.bind(this),
    //   // onAudioEnd: this.onAudioEnd.bind(this),
    //   // onPatternClick: this.onPatternClick.bind(this)
    // };
    return (
      <Row>
        <Col className='info_table dashboard' xs={12} md={10} mdOffset={1}>
          <AssignmentTitle chapterNumber={chapterNumber} chapterTitle={chapterTitle} category={category} />
          {assignments ? (
              <AssignmentDetails
                contents={assignments}
                // chapterNumber={chapterNumber}
                chapterTitle={chapterTitle}
                category={category}
                // isCompleted={isCompleted}
              />
          ) : (
            <Spinner />
          )}
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getAssignments: (memberChapterId, category) => {
      dispatch(getAssignments(memberChapterId, category));
    }
  };
};

const mapStateToProps = state => {
  return {
    assignments: state.dashboard.assignments,
    chapters: state.dashboard.chapters,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentContainer);



// WEBPACK FOOTER //
// ./src/containers/AssignmentContainer.js